import _ from 'lodash';
import moment from 'moment';
import { IEventBracketMatchDetails, MatchStatus } from '../../../../../../types/eventBracketTypes';
import { ActiveGameMatchMode } from '../../../../events/store/details/types';

export type TColors = {
  backgroundColor: string;
  borderColor: string;
};

export const getColorsByRound = (round: number): TColors => {
  switch (round) {
    case 1: {
      return {
        backgroundColor: 'rgba(129, 223, 255, 0.35)',
        borderColor: 'rgb(129, 223, 255)'
      };
    }
    case 2: {
      return {
        backgroundColor: 'rgba(0, 199, 177, 0.35)',
        borderColor: 'rgb(0, 199, 177)'
      };
    }
    default: {
      return {
        backgroundColor: 'rgba(255, 244, 71, 0.35)',
        borderColor: 'rgba(255, 244, 71, 0.1)'
      };
    }
  }
};

export const getMatchByMode = (
  matches: IEventBracketMatchDetails[],
  mode: ActiveGameMatchMode = ActiveGameMatchMode.Latest
) => {
  if (mode === ActiveGameMatchMode.Latest) {
    const inProgressMatches = matches.filter((match) => match.status === MatchStatus.IN_PROGRESS);

    if (inProgressMatches.length) {
      const mostRecentlyUpdatedInProgressMatch = inProgressMatches.sort(sortMatchesByMostRecentlyUpdated)[0];
      return mostRecentlyUpdatedInProgressMatch;
    }

    const completedMatches = matches.filter((match) => match.status === MatchStatus.COMPLETE);

    if (completedMatches.length) {
      const mostRecentlyUpdatedCompletedMatch = completedMatches.sort(sortMatchesByMostRecentlyUpdated)[0];
      return mostRecentlyUpdatedCompletedMatch;
    }
  }

  if (mode === ActiveGameMatchMode.Follow) {
    const mostRecentlyUpdatedMatch = matches.sort(sortMatchesByMostRecentlyUpdated)[0];
    return mostRecentlyUpdatedMatch;
  }

  return null;
};
export const sortMatchesByMostRecentlyUpdated = (a: IEventBracketMatchDetails, b: IEventBracketMatchDetails) => {
  const getDates = (match: IEventBracketMatchDetails) => {
    return [match.updatedAt, ...(match.games || []).map((game) => game.updatedAt)]
      .flat()
      .filter(Boolean)
      .map((date) => moment.utc(date));
  };

  const newest = (dates: moment.Moment[]) => (dates.length ? _.maxBy(dates, (d) => d.valueOf())! : moment.utc(0));

  return newest(getDates(b)).diff(newest(getDates(a)));
};
